import { Game } from '@/constants/game.const';
import type {
  BackofficeVideoGame,
  RssFeedGame,
  StrapiGame,
} from '@/types/game';

export const getGameFromStrapiGame = (game: StrapiGame): Game => {
  switch (game) {
    case 'CS':
      return Game.CS2;
    case 'Dota':
      return Game.DOTA;
    case 'LoL':
      return Game.LOL;
    default:
      game satisfies never;
      throw new Error(`Unknown game: ${game}`);
  }
};

export const getGameFromBackofficeVideoGame = (
  game: BackofficeVideoGame | null | undefined
): Game | null => {
  switch (game) {
    case 'cs-go':
      return Game.CS2;
    case 'dota-2':
      return Game.DOTA;
    case 'lol':
      return Game.LOL;
    case null:
    case undefined:
      return null;
    default:
      throw new Error(`Unknown game: ${game}`);
  }
};

export const getGameFromRssFeedGame = (
  game: RssFeedGame | null | undefined
): Game | null => {
  switch (game) {
    case 'Dota':
      return Game.DOTA;
    case 'CS':
      return Game.CS2;
    case null:
    case undefined:
      return null;
    default:
      throw new Error(`Unknown game: ${game}`);
  }
};

export const getRssFeedGameFromGame = (game: Game): RssFeedGame | null => {
  switch (game) {
    case Game.CS2:
      return 'CS';
    case Game.DOTA:
      return 'Dota';
    // NOTE: LoL is not yet supported in the app
    case Game.LOL:
      return null;
    default:
      game satisfies never;
      throw new Error(`Unknown game: ${game}`);
  }
};

export function getStrapiGameFromGame(game: Game): StrapiGame {
  switch (game) {
    case Game.CS2:
      return 'CS';
    case Game.DOTA:
      return 'Dota';
    case Game.LOL:
      return 'LoL';
    default:
      game satisfies never;
      throw new Error(`Unsupported game: ${game}`);
  }
}

export function mapGameFilterToVideoGameName(filter: Game): string | undefined {
  switch (filter) {
    case Game.CS2:
      return 'Counter-Strike';
    case Game.DOTA:
      return 'Dota 2';
    default:
      return;
  }
}
